import { Navigate, useParams } from 'react-router';

function SPGQSpecialRoutes({ formulaire }: { formulaire: string }) {
  const params = useParams<{ idEmploye: string }>();
  return <Navigate to={`/formulaire/spgq/${formulaire}/${params.idEmploye}`} />;
}


export default SPGQSpecialRoutes;
